app.controller("DetailsController", ["$scope", "StSubject", "$uibModalInstance", "subject",
    function ($scope, StSubject, $uibModalInstance, subject) {
        $scope.subject = subject;
        $scope.grades = subject.details;

        $scope.gradeColor = function (grade) {
            if (grade.grade && grade.grade.absolute && grade.minValue > grade.grade.absolute) return 'red';
            if (grade.replaced) return 'gray';
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);